const Cookies = require('js-cookie');

$('.special .close').click(function () {
    let $special = $(this).closest('.special');
    $special.slideUp();
    Cookies.set('hide_special', $special.data('specialid'), {expires: 7});
});
